import React from 'react';
import LogoIcon from 'components/LogoIcon';

function AuthTop({ children, hideLogo = false }) {
  return (
    <div className="auth-top">
      <div className="child">
        {!hideLogo && <LogoIcon />}
        {children}
      </div>
    </div>
  );
}

export default AuthTop;
